export const EnhancedReturnsAccountStatusEnum = {
  Active: 'Active',
  Inactive: 'Inactive',
  Requested: 'Requested',
};
